import Script from "next/script";

const Taboola = () => { 

    return (
        null
    )
}

export default Taboola;